import napStyles from './../nap.json'

export default {
  name: 'B3',
  color: napStyles.colors.PrimaryBlack,
  fontStyle: 'italic'
}
